const ErrorPageIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_3503_77426" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
        <rect width="32" height="32" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3503_77426)">
        <path
          d="M1.3335 28.0001L16.0002 2.66675L30.6668 28.0001H1.3335ZM5.9335 25.3334H26.0668L16.0002 8.00008L5.9335 25.3334ZM16.0002 24.0001C16.3779 24.0001 16.6946 23.8723 16.9502 23.6167C17.2057 23.3612 17.3335 23.0445 17.3335 22.6667C17.3335 22.289 17.2057 21.9723 16.9502 21.7167C16.6946 21.4612 16.3779 21.3334 16.0002 21.3334C15.6224 21.3334 15.3057 21.4612 15.0502 21.7167C14.7946 21.9723 14.6668 22.289 14.6668 22.6667C14.6668 23.0445 14.7946 23.3612 15.0502 23.6167C15.3057 23.8723 15.6224 24.0001 16.0002 24.0001ZM14.6668 20.0001H17.3335V13.3334H14.6668V20.0001Z"
          fill="#D91313"
        />
      </g>
    </svg>
  );
};

export default ErrorPageIcon;
